export const serverConfig = {
    env: process.env.ENV,
    api: process.env.REACT_APP_API_URL,
  };
  